/*
 * Copyright (C) 2020 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export type EShapeLineOfAnyValue = null | number | number[] | ((index: number) => number);
